/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import useSheet from 'app/jss';

type Props = {
  classes: Object,
  children: any,
  className?: string,
  link?: string,
  onClick?: () => void,
};

const defaultProps = {
  className: undefined,
  link: undefined,
  onClick: undefined,
};

function Card({
  classes,
  children,
  className,
  link,
  onClick,
}: Props) {
  return (
    <div className={classNames(classes.card, className)}>
      <Tappable
        className={classNames(classes.inner)}
        component={link ? Link : 'div'}
        onTap={onClick}
        to={link}
      >
        {children}
      </Tappable>
    </div>
  );
}

Card.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    card: {
      height: '100%',
      width: '100%',
    },
    inner: {
      height: '100%',
      width: '100%',
      display: 'block',
      borderRadius: 8,
      color: theme.color.basis1,
      zIndex: 1, // hack to hide border overflow
      // WARNING!!! - don't place backgrounds here
      // By placing a background at the top level, you invite
      // border-radius background-bleed problems if elements
      // near the radius has a different background colour
      // Instead, apply your backgrounds to the parts you need it on separately
    },
  };
}

export default useSheet(applyStyles)(Card);
